import { Observable } from 'rxjs';
import { UseCase } from '../../base/use-case';
import { ConsultRepository } from '../../repositories/consult.repository';
import { TypeModalityModel } from '../../models/consult/type-modality.model';
export class GetTypeModalityByIdUseCase implements UseCase<{id: string }, TypeModalityModel> {
    constructor(private ConsultRepository: ConsultRepository) { }
    execute(
        params: {id: string },
    ): Observable<TypeModalityModel> {
        return this.ConsultRepository.getTypeModalityById(params);
    }
}